<template>
  <el-dialog
    :visible="!!session"
    :append-to-body="true"
    :lock-scroll="false"
    :center="true"
    top="2vh"
    key="session-viewer"
    v-on:close="$emit('update:session', null)"
  >
    <div>
      <div class="px-6 py-4 mx-4 md:mx-16 bg-brand-light-blue rounded-lg shadow-sm mb-6 text-brand-black flex space-x-4">
        <div class="flex-grow-0 flex-shrink-0">
          <img src="@/assets/img/web-install.png" class="w-12 h-auto inline-block mt-2" alt="Web Install" />
        </div>
        <div class="space-y-2">
          <p class="font-semibold">Please note...</p>
          <p>
            Our session recording is optimized to minimally impact your website's performance. We streamline event data and recreate the session in a
            way that is as close to the original as possible. However, since this is not a true video recording, there may be some errors in the
            replayed session compared to the original.
          </p>
        </div>
      </div>
      <div class="player-container" v-loading="isLoading">
        <div id="replayer" class="pb-4"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import RRWebPlayer from 'rrweb-player';
import 'rrweb-player/dist/style.css';
import SessionService from '@/api/session.service';

export default {
  name: 'SessionViewer',
  props: ['session'],
  data() {
    return {
      sessionEvents: null,
      isLoading: true,
    };
  },

  async mounted() {
    // get session data
    await this.getSessionData();
    this.initPlayer();
  },

  watch: {
    session: {
      immediate: true,
      handler(val, oldVal) {
        this.sessionEvents = val;
        if (val) {
          this.loadNewSession();
        }
      },
    },
  },

  methods: {
    initPlayer() {
      // set up player
      // eslint-disable-next-line no-new
      new RRWebPlayer({
        target: document.getElementById('replayer'),
        data: {
          events: this.sessionEvents,
          skipInactive: true,
          autoPlay: true,
        },
      });
    },

    async getSessionData() {
      try {
        // generate secure signed url
        const signedUrl = await SessionService.getSignedSession(this.session.recording);
        const res = await fetch(signedUrl);
        this.sessionEvents = await res.json();
      } catch (err) {
        console.log('Error', err);
      } finally {
        this.isLoading = false;
      }
    },

    async loadNewSession() {
      const replayEl = document.getElementsByClassName('rr-player')[0];
      if (replayEl) replayEl.remove();
      const rrwebEl = document.getElementById('replayer');
      await this.getSessionData();
      // eslint-disable-next-line no-new
      new RRWebPlayer({
        target: rrwebEl,
        data: {
          events: this.sessionEvents,
          autoPlay: true,
        },
      });
    },
  },
};
</script>
